/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 *
 * EosTransferMediaStudyStatusFilter — Active/Archived/All radio filter for study list.
 * Migrated from: lego/page/eos/transfer-media/EosTransferMediaStudyStatusFilter.jsx
 */

import { useState, useRef, useEffect } from 'react'
import { Button, Collapse } from 'react-bootstrap'
import { useServiceContext } from '../../../root'
import type { EosTransferMediaStudyStatusFilterProps, StudyStateFilter } from './types'

const EosTransferMediaStudyStatusFilter: React.FC<EosTransferMediaStudyStatusFilterProps> = ({ filterList }) => {
  const context = useServiceContext()
  const { translate } = context.service.filter
  const [collapsed, setCollapsed] = useState(true)
  const subscriptions = useRef<Array<() => void>>([])
  const [selection, setSelection] = useState<StudyStateFilter>('ACTIVE')

  useEffect(() => {
    const handler = (event: Event) => {
      const detail = (event as CustomEvent)?.detail
      if (detail?.collapsed !== undefined) {
        setCollapsed(detail.collapsed)
      }
    }
    context.bus.addEventListener('FILTER_TOGGLE', handler)
    subscriptions.current.push(() => context.bus.removeEventListener('FILTER_TOGGLE', handler))

    return () => {
      subscriptions.current.forEach((unsub) => unsub())
    }
  }, [])

  const doFilter = () => {
    filterList(selection)
  }

  const doReset = () => {
    setSelection('ACTIVE')
  }

  return (
    <Collapse in={collapsed}>
      <div className="eos-transfer-media filter-wrapper">
        <label className="control-label">{translate('STUDY_STATE')}</label>
        <div className="state-selection">
          <input
            className="state-radio"
            type="radio"
            name="state"
            value="ACTIVE"
            checked={selection === 'ACTIVE'}
            onClick={() => setSelection('ACTIVE')}
            onChange={() => {
              /* prevent React warning */
            }}
          />
          <label className="state-value">{translate('ACTIVE')}</label>
        </div>
        <div className="state-selection">
          <input
            className="state-radio"
            type="radio"
            name="state"
            value="ARCHIVED"
            checked={selection === 'ARCHIVED'}
            onClick={() => setSelection('ARCHIVED')}
            onChange={() => {
              /* prevent React warning */
            }}
          />
          <label className="state-value">{translate('ARCHIVED')}</label>
        </div>
        <div className="state-selection">
          <input
            className="state-radio"
            type="radio"
            name="state"
            value="ALL"
            checked={selection === 'ALL'}
            onClick={() => setSelection('ALL')}
            onChange={() => {
              /* prevent React warning */
            }}
          />
          <label className="state-value">{translate('ALL')}</label>
        </div>
        <div className="action-buttons theme-sandman">
          <Button className="btn btn-primary" onClick={doFilter}>
            {translate('BTN_FILTER')}
          </Button>
          <Button className="btn btn-chita btn-link reset-button" onClick={doReset}>
            {translate('BTN_CLEAR_FILTER')}
          </Button>
        </div>
      </div>
    </Collapse>
  )
}

export default EosTransferMediaStudyStatusFilter
